module.exports = __webpack_public_path__ + "static/35-67842fdf73e4a8ed81fd1236f6314e95.jpg";